import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Typography } from '@material-ui/core'

const DashBoard = (props) => {
    return (
        <>
            <div className="body" component="main">
                <CssBaseline />
                <div className="main-wrapper">
                    <div className="d-flex flex-row-reverse">
                        <Typography
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: '20px',
                            }}
                        >
                            Welcome to Vayana Payment Gateway
                        </Typography>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DashBoard
